import { ESearchLevel } from '../../../types-library/src'

export const tileZoomConfiguration = {
  state: {
    minZoom: 9,
    maxZoom: 11,
  },
  municipality: {
    minZoom: 11,
    maxZoom: 13,
  },
  neighborhood: {
    minZoom: 13,
    maxZoom: 15,
  },
  block: {
    minZoom: 15,
    maxZoom: 18,
  },
  property: {
    minZoom: 18,
    maxZoom: 22,
  },
}

export function getDesiredZoomLevel(params: { zoom: number }): {
  zoom: number
  minZoom: number
  maxZoom: number
} {
  const { zoom } = params

  const count = `${zoom}`.split('.')[0]

  const toNumber = Number(count)

  if (toNumber <= 9) {
    return { zoom: 9, minZoom: 0, maxZoom: 10 }
  }

  if (toNumber >= 16) {
    return { zoom: 16, minZoom: 16, maxZoom: 22 }
  }

  return { zoom: parseInt(count, 10), minZoom: zoom, maxZoom: zoom + 1 }
}

export const zoomLevel = {
  [ESearchLevel.STATE]: 9,
  [ESearchLevel.MUNICIPALITY]: 11,
  [ESearchLevel.NEIGHBORHOOD]: 13,
  [ESearchLevel.BlOCK]: 15,
  [ESearchLevel.PROPERTY]: 18,
}

/**
 * This function is used to get the search level by zoom
 * @param zoom The zoom level of the map
 * @returns {ESearchLevel}
 */
export function getSearchLevelByZoom(params: { zoom: number }): ESearchLevel {
  const { zoom } = params

  if (zoom <= zoomLevel[ESearchLevel.STATE]) {
    return ESearchLevel.STATE
  }

  if (zoom <= zoomLevel[ESearchLevel.MUNICIPALITY]) {
    return ESearchLevel.MUNICIPALITY
  }

  if (zoom <= zoomLevel[ESearchLevel.NEIGHBORHOOD]) {
    return ESearchLevel.NEIGHBORHOOD
  }

  if (zoom <= zoomLevel[ESearchLevel.BlOCK]) {
    return ESearchLevel.BlOCK
  }

  return ESearchLevel.PROPERTY
}
